import * as React from 'react';
import { Field, WrappedFieldInputProps } from 'redux-form';
import JRCFormFieldRender, { InputState, JRCWritableFormInputProps } from '../JRCFormFieldRender';
import { useControls } from '../ReduxFormControls';
import { useIntl } from 'react-intl';
import { MaxLengthIndicator, StyledInput } from '../../JRCStyledInput';

const renderInput = (props: JRCWritableFormInputProps, input: any, inputState: InputState) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const inputRef = React.useRef<HTMLInputElement>(null);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(() => {
        if (props.selected || false) {
            inputRef && inputRef.current && inputRef.current.select();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [inputRef]);
    return (
        <>
            <MaxLengthIndicator maxLength={props.maxLength} actualLength={input.value.length} />
            <StyledInput ref={inputRef} id={props.name} type="text" {...props} {...input} {...inputState} />
        </>
    );
};

/**
 * Component used as a <input type="text"/>
 * @param props JRCWritableFormInputProps
 * validation props: minLength, maxLength, required
 * @returns JSX.Element
 * @deprecated Use JRCInputText or JRCInputTextArea instead
 */
export const JRCFormTextField = (props: JRCWritableFormInputProps) => {
    const validate = useControls({
        intl: useIntl(),
        minLength: props.minLength,
        maxLength: props.maxLength,
        required: props.required,
    });
    return (
        <Field
            component={JRCFormFieldRender}
            renderInputFct={(input: WrappedFieldInputProps, inputState: InputState) =>
                renderInput(props, input, inputState)
            }
            validate={validate}
            htmlFor={props.name}
            {...props}
        />
    );
};
